/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/divider/custom-elements';

import { defineCustomElement as defineOsdsDivider } from '@ovhcloud/ods-stencil/components/divider/custom-elements/osds-divider.js';


export const OsdsDivider = /*@__PURE__*/ defineContainer<JSX.OsdsDivider>('osds-divider', defineOsdsDivider, [
  'separator',
  'color',
  'size',
  'contrasted'
]);

